import type {
  CompiledFormViewConfig,
  CompiledKpiPivotViewConfig,
  CompiledKpiViewConfig,
  CompiledSheetViewConfig,
  ViewQueryList,
} from '@salescore/core'
import type { ReactElement } from 'react'

import type { RSheetColumn, RSheetRecordNode } from '../../../domain/column'
import type { RSheetsCursor } from '../../../domain/cursor/cursorTypes'
import type { RSheetContext } from '../../../recoil/context'
import { type CursorPosition, useCursorMutation } from '../../../recoil/cursor'
import type { SalescoreObjectAbility, ViewAbility } from '../../../recoil/view/atoms'
import { useClickCurrentCursorMutation } from '../../recoil/mutations/cursor/clickCurrentCursorMutation'
import { RSheetsStyle } from '../../util/RSheetsStyle'

export const MainCursorBox = ({
  cursor: { expand, main },
  position: { height, width, x, y },
  headerHeight,
  fixedLeftColumnIndex,
  context,
  column,
  columns,
  compiledConfig,
  setDragging,
  ability,
  query,
  visibleRowNumber,
}: {
  cursor: RSheetsCursor
  position: CursorPosition
  headerHeight: number
  fixedLeftColumnIndex: number
  context: RSheetContext
  column: RSheetColumn<RSheetRecordNode>
  columns: Array<RSheetColumn<RSheetRecordNode>>
  compiledConfig: CompiledSheetViewConfig | CompiledKpiViewConfig | CompiledKpiPivotViewConfig | CompiledFormViewConfig
  setDragging: () => void
  ability: ViewAbility & SalescoreObjectAbility
  query: ViewQueryList | undefined
  visibleRowNumber: number | undefined
}): ReactElement => {
  const clickCurrentCursorMutation = useClickCurrentCursorMutation(
    context,
    columns,
    compiledConfig,
    ability,
    query,
    visibleRowNumber,
  )
  const { setContextMenuPosition } = useCursorMutation(ability)

  return (
    <div
      style={{
        // div がチェックボックスの上になる場合は、divのクリックを無効化する
        pointerEvents: column.type === 'checkbox' || column.type === 'boolean' ? 'none' : undefined,
        position: 'absolute',
        top: y + headerHeight,
        left: x,
        width,
        height,
        border: expand === undefined ? `2px #3274E0 solid` : undefined,
        borderRadius: 4,
        transition: RSheetsStyle.cursorTransition,
        zIndex:
          main.columnIndex < fixedLeftColumnIndex
            ? RSheetsStyle.zIndex.cursorWhenLeftFixed
            : RSheetsStyle.zIndex.cursor,
      }}
      onClick={() => {
        clickCurrentCursorMutation({})
      }}
      onPointerDown={setDragging}
      onContextMenu={(e) => {
        const contextMenuPosition = {
          x: e.clientX,
          y: e.clientY,
        }
        setContextMenuPosition(main, contextMenuPosition)
        e.preventDefault()
        e.stopPropagation()
      }}
    ></div>
  )
}
